import React, { useState, useContext, useEffect, ChangeEvent } from 'react'
import { useHistory } from 'react-router-dom'
import { FirebaseError } from '@firebase/util'
import CssBaseline from '@mui/material/CssBaseline'
import LoadingButton from '@mui/lab/LoadingButton'
import FormControlLabel from '@mui/material/FormControlLabel'
import { ShowPasswordButton } from 'src/components/Buttons/ShowPasswordButton'

import { AuthContext } from 'src/context/auth/authContext'
import { Checkbox, Link, Grid, Box, FormHelperText } from '@mui/material'

import {
  LoginContainer, Main, WelcomeBox, LogoArea, LogoText, LogoSubtitle,
  FormTitle, FormSubtitle, InputGroup, Input, PrimaryButton, SecondaryButton,
  DecorativePanel, Particle, Hexagon, PulseLine, CircuitLine, CircuitDot,
  DnaContainer, DnaDot, RightContent, FeaturePills, Pill
} from './welcome.styles'
import { ReactComponent as Logo } from 'src/assets/icons/general/Metaphysio.svg'
import { RecoverPasswordDialog, SimpleDialog } from 'src/components/Modals/Dialog'
import { recoverAccountPassword } from 'src/services/auth.services'
import { labels } from 'src/labels/main_labels'
import { validateEmail } from 'src/utils/validateForm'
import Swal from 'sweetalert2'
import { getAuth, getRedirectResult, AdditionalUserInfo, getAdditionalUserInfo, linkWithCredential } from 'firebase/auth'
import { rolesObj, sectorsObj, storesObj } from 'src/scripts/datats'
import { signInAgain } from 'src/utils/swal.utils'

export default function Welcome(): JSX.Element {
  const history = useHistory()
  const [error, setError] = useState<string | null>(null)
  const [openRecoverPass, setOpenRecoverPass] = useState<boolean>(false)
  const [openRecoverPassError, setOpenRecoverPassError] = useState<boolean>(false)
  const [persistence, setPersistence] = useState<boolean>(true)
  const [loading, setLoading] = useState(false)
  const [loadingRecover, setLoadingRecover] = useState(false)
  const [recoverPasswordDialog, setRecoverPasswordDialog] = useState(false)
  const [values, setValues] = useState({ email: '', password: '' })
  const [showPassword, setShowPassword] = useState(false)

  const { firebase, userData, initLoading, language } = useContext(AuthContext)

  // REDIRECT FLUJO OIDC
  // useEffect(() => {
  //   ;(async () => {
  //     const auth = getAuth()

  //     getRedirectResult(auth)
  //       .then(async (result) => {
  //         console.log(result)
  //         if (result && result?.user) {
  //           const userData: AdditionalUserInfo | null = getAdditionalUserInfo(result)

  //           // Expresión regular para buscar específicamente 'ROLE-METAPHYSIO-ROLE_' seguido de un número
  //           const pattern = /ROLE-METAPHYSIO-ROLE_(\d+)/

  //           // Filtrar y extraer el número
  //           const roleNumber = (userData?.profile?.memberof as any).reduce((acc: any, item: any) => {
  //             const match = item.match(pattern)
  //             if (match) {
  //               acc.push(match[1]) // extrae el número encontrado después de 'ROLE-METAPHYSIO-ROLE_'
  //             }
  //             return acc
  //           }, [])

  //           if (!roleNumber) {
  //             const user = auth.currentUser
  //             user
  //               ?.delete()
  //               .then(async () => {
  //                 Swal.fire({
  //                   icon: 'error',
  //                   width: 440,
  //                   confirmButtonText: 'OK',
  //                   confirmButtonColor: '#1870c7',
  //                   html: `<h6>Acceso no permitido</h4>`,
  //                   showConfirmButton: true
  //                 })
  //                 console.log('user deleted due to not permission')
  //               })
  //               .catch(async (error: any) => {
  //                 await firebase.db
  //                   .collection('errorslogs')
  //                   .add({ error: JSON.stringify(error, Object.getOwnPropertyNames(error)), createdAt: Date.now() })
  //                 console.log(error)
  //               })

  //             return
  //           }

  //           if (userData?.isNewUser) {
  //             const userInfo = firebase.db.collection('users').doc(result.user.uid)
  //             if (userData.profile) {
  //               await firebase.db.collection('pingidlogs').add({ ...userData?.profile, success: 'new', createdAt: Date.now() })
  //             }
  //             await userInfo
  //               .set({
  //                 birthday: '01/01/1900',
  //                 company: { id: 'xnR745oszYN4mRTAJiLY', name: 'Obramat (BRICOLAJE BRICOMAN, S.L.U.)' },
  //                 companyId: 'xnR745oszYN4mRTAJiLY',
  //                 createdAt: Date.now(),
  //                 comunPatology: { id: false, name: 'No' },
  //                 comunPatologyBookings: 0,
  //                 deleted: false,
  //                 createdBy: 'oidc',
  //                 method: 'oidc',
  //                 email: result.user.email,
  //                 employeeId: userData?.profile?.uid,
  //                 fullName: userData?.profile?.name,
  //                 id: result.user.uid,
  //                 lastname: userData?.profile?.family_name,
  //                 lastname2: '',
  //                 name: userData?.profile?.given_name,
  //                 role: { ...rolesObj[String(userData?.profile?.title)], id: `role${roleNumber}` },
  //                 sector: userData?.profile?.departmentnumber ? sectorsObj[String(userData?.profile.departmentnumber)] : null,
  //                 // role: {
  //                 //   ...(roles.find((role) => removeAccents(role.name).toLowerCase() === String(userData?.profile?.title)?.toLowerCase()) || {
  //                 //     id: `role${roleNumber}`,
  //                 //     name: userData?.profile?.title
  //                 //   }),
  //                 //   id: `role${roleNumber}`
  //                 // },
  //                 // sector: userData?.profile?.departmentnumber
  //                 //   ? [
  //                 //       sectors.find(
  //                 //         (sector) => removeAccents(sector.name).toLowerCase() === String(userData?.profile?.departmentnumber).toLowerCase()
  //                 //       )
  //                 //     ]
  //                 //   : null,
  //                 store: storesObj[String(userData?.profile?.businesscategory)],
  //                 storeId: storesObj[String(userData?.profile?.businesscategory)].id,
  //                 // store: stores.find((store) =>
  //                 //   removeAccents(store.name).toLowerCase().includes(String(userData?.profile?.businesscategory).toLowerCase())
  //                 // ),
  //                 // storeId: stores.find((store) =>
  //                 //   removeAccents(store.name).toLowerCase().includes(String(userData?.profile?.businesscategory).toLowerCase())
  //                 // )?.id,
  //                 workingSince: String(userData?.profile?.privContractStartDate).split('/').reverse().join('/'),
  //                 gender: { id: '-', name: '-' }
  //               })
  //               .then(async () => console.log('done info'))
  //             if (userData?.profile?.departmentnumber === 'ACABADO') {
  //               const updateEmployeeSector = firebase.functions.httpsCallable('getSectorSexBirthday')

  //               try {
  //                 return await updateEmployeeSector(result.user.email)
  //               } catch (error) {
  //                 console.log(error)

  //                 throw new Error('Hubo un error mientras actualizabamos el sector')
  //               }
  //             }
  //           } else {
  //             console.log('usuario ya existia')
  //             const userInfo = await firebase.db.collection('users').doc(result.user.uid)

  //             if (userData?.profile) {
  //               await firebase.db.collection('pingidlogs').add({ ...userData?.profile, success: 'old', createdAt: Date.now() })
  //             }

  //             await userInfo
  //               .update({
  //                 deleted: false,
  //                 email: result.user.email,
  //                 employeeId: userData?.profile?.uid,
  //                 fullName: userData?.profile?.name,
  //                 lastname: userData?.profile?.family_name,
  //                 lastname2: '',
  //                 name: userData?.profile?.given_name,
  //                 // role: {
  //                 //   ...(roles.find((role) => removeAccents(role.name).toLowerCase() === String(userData?.profile?.title)?.toLowerCase()) || {
  //                 //     id: `role${roleNumber}`,
  //                 //     name: userData?.profile?.title
  //                 //   }),
  //                 //   id: `role${roleNumber}`
  //                 // },
  //                 // sector: userData?.profile?.departmentnumber
  //                 //   ? [
  //                 //       sectors.find(
  //                 //         (sector) => removeAccents(sector.name).toLowerCase() === String(userData?.profile?.departmentnumber).toLowerCase()
  //                 //       )
  //                 //     ]
  //                 //   : null,
  //                 role: { ...rolesObj[String(userData?.profile?.title)], id: `role${roleNumber}` },
  //                 sector: userData?.profile?.departmentnumber ? sectorsObj[String(userData?.profile.departmentnumber)] : null,
  //                 store: storesObj[String(userData?.profile?.businesscategory)],
  //                 storeId: storesObj[String(userData?.profile?.businesscategory)].id
  //               })
  //               .then(() => console.log('done info'))
  //               .catch(async (error: any) => {
  //                 await firebase.db
  //                   .collection('errorslogs')
  //                   .add({ error: JSON.stringify(error, Object.getOwnPropertyNames(error)), createdAt: Date.now() })
  //                 console.log(error)
  //               })
  //             if (userData?.profile?.departmentnumber === 'ACABADO') {
  //               const updateEmployeeSector = firebase.functions.httpsCallable('getSectorSexBirthday')

  //               try {
  //                 return await updateEmployeeSector(result.user.email)
  //               } catch (error) {
  //                 await firebase.db
  //                   .collection('errorslogs')
  //                   .add({ error: JSON.stringify(error, Object.getOwnPropertyNames(error)), createdAt: Date.now() })
  //                 console.log(error)

  //                 throw new Error('Hubo un error mientras actualizabamos el sector')
  //               }
  //             }
  //           }
  //         }
  //       })
  //       .catch(async (error) => {
  //         console.log(error)
  //       })
  //     //         .catch(async (error) => {
  //     //           console.log(error)
  //     //           await firebase.db
  //     //             .collection('errorslogs')
  //     //             .add({ error: JSON.stringify(error, Object.getOwnPropertyNames(error)), createdAt: Date.now() })
  //     //           if (error.toString().includes('account-exists-with-different-credential')) {
  //     //             const credential = OAuthProvider.credentialFromError(error)

  //     //             if (credential) {
  //     //               Swal.fire({
  //     //                 title: 'Vincular cuenta',
  //     //                 confirmButtonText: 'Vincular',
  //     //                 confirmButtonColor: '#1870c7',
  //     //                 showLoaderOnConfirm: true,
  //     //                 allowOutsideClick: () => !Swal.isLoading(),
  //     //                 html: `
  //     //   <span class="swal2-span" styles={{fontSize:'10px'}}>Introduce tu email y contraseña de Metaphysio</span>
  //     //   <input id="swal-input1" class="swal2-input" placeholder="Email" type="email">
  //     //   <input id="swal-input2" class="swal2-input" placeholder="Contraseña" type="password">
  //     // `,
  //     //                 focusConfirm: false,
  //     //                 preConfirm: () => {
  //     //                   firebase
  //     //                     .auth()
  //     //                     .signInWithEmailAndPassword(
  //     //                       (document.getElementById('swal-input1') as HTMLInputElement)!.value,
  //     //                       (document.getElementById('swal-input2') as HTMLInputElement)!.value
  //     //                     )
  //     //                     .then((result:any) => {
  //     //                       if (credential && result.user) {
  //     //                         return linkWithCredential(result.user, credential)
  //     //                           .then(() => {
  //     //                             // Sign in with the newly linked credential
  //     //                             return firebase.auth.signInWithCredential(credential)
  //     //                           })
  //     //                           .then((signInResult: any) => {
  //     //                             // Save the merged data to the new user

  //     //                             Swal.fire(signInAgain('#1870c7'))
  //     //                             firebase.auth.signOut()
  //     //                             // window.location.reload()
  //     //                           })
  //     //                       }
  //     //                     })
  //     //                     .catch(async (error:any) => {
  //     //                       await firebase.db
  //     //                         .collection('errorslogs')
  //     //                         .add({ error: JSON.stringify(error, Object.getOwnPropertyNames(error)), createdAt: Date.now() })
  //     //                       if ((error as any).code === 'auth/wrong-password') {
  //     //                         Swal.fire({
  //     //                           icon: 'error',
  //     //                           width: 440,
  //     //                           confirmButtonText: 'OK',
  //     //                           confirmButtonColor: '#1870c7',
  //     //                           html: `<h6>La contraseña es incorrecta, inténtelo de nuevo</h4>`,
  //     //                           showConfirmButton: true
  //     //                         })
  //     //                       } else if ((error as any).code === 'auth/too-many-requests') {
  //     //                         Swal.fire({
  //     //                           icon: 'error',
  //     //                           width: 440,
  //     //                           confirmButtonText: 'OK',
  //     //                           confirmButtonColor: '#1870c7',
  //     //                           html: `<h6>El usuario se ha bloqueado por seguridad, inténtelo de nuevo mas tarde</h4>`,
  //     //                           showConfirmButton: true
  //     //                         })
  //     //                       } else {
  //     //                         Swal.fire({
  //     //                           icon: 'error',
  //     //                           width: 440,
  //     //                           confirmButtonText: 'OK',
  //     //                           confirmButtonColor: '#1870c7',
  //     //                           html: `<h6>Ha habido un error, inténtelo de nuevo</h4>`,
  //     //                           showConfirmButton: true
  //     //                         })
  //     //                       }
  //     //                       // If there are errors we want to undo the data merge/deletion
  //     //                       console.log('Sign In Error', error)
  //     //                     })
  //     //                 }
  //     //               })
  //     //             }
  //     //           }
  //     //         })
  //   })()
  // }, [])

  useEffect(() => {
    return () => setLoading(false)
  }, [])

  const loginWithOIDC = async () => {
    firebase
      .loginRed()
      .then(() => {
        history.push('/')
        if (!document.getElementsByClassName('swal2-input')[0] && !userData) {
          window.location.reload()
        }
        // if (!userData) window.location.reload()
      })
      .catch((error: any) => console.log(error))
  }

  // const loginWithOIDCRedirect = async (e: any) => {
  //   if (typeof e.cancelable !== 'boolean' || e.cancelable) {
  //     console.log('The event can be canceled')
  //     // The event can be canceled, so we do so.
  //     e.preventDefault()
  //   } else {
  //     // The event cannot be canceled, so it is not safe
  //     // to call preventDefault() on it.
  //     console.warn(`The following event couldn't be canceled:`)
  //     console.dir(e)
  //   }

  //   await firebase
  //     .oidcRedirect()
  //     // .then(() => {
  //     //   history.push('/')
  //     //   if (!document.getElementsByClassName('swal2-input')[0] && !userData) {
  //     //     window.location.reload()
  //     //   }
  //     //   // if (!userData) window.location.reload()
  //     // })
  //     .catch((error: any) => console.log(error))
  // }

  const handleSubmit = (event: any) => {
    setError(null)
    event.preventDefault()

    // const data = new FormData(event.currentTarget)
    if (!values.email || !values.password) return
    if (!validateEmail(values.email)) {
      setError(labels[language].emailError)
      return
    }
    setLoading(true)

    firebase
      .login(values.email, values.password, persistence)
      .then(() => history.push('/'))
      .catch(async (error: unknown) => {
        setLoading(false)
        if (error instanceof FirebaseError) {
          console.log(error.message)
          if (error.message.includes('EMAIL_NOT_FOUND')) {
            setError(labels[language].ERR_INVALID_EMAIL)
          } else if (error.message.includes('wrong-password')) {
            setError(labels[language].ERR_WRONG_PASS)
          } else if (error.message.includes('attempts')) {
            setError(labels[language].ERR_PASS_WRONG_TIMES)
          } else if (error.message.includes('requirements')) {
            try {
              setError(labels[language].ERR_PASS_REQUIREMENTS)
              // await recoverAccountPassword(data.get('email') as string)
            } catch (error) {
              console.log(error)
            }
          } else {
            setError(labels[language].ERR_NO_EMAIL)
          }
        }
      })
  }

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setValues({ ...values, [e.target.name]: e.target.value })
  }

  const recoverPassword = (email: string) => {
    setLoadingRecover(true)
    recoverAccountPassword(email)
      .then(() => {
        setRecoverPasswordDialog(false)
        setOpenRecoverPass(true)
        setLoadingRecover(false)
      })
      .catch(() => {
        setOpenRecoverPassError(true)
        setLoadingRecover(false)
      })
  }

  return (
    <LoginContainer>
      <CssBaseline />
      {/* LEFT: Form */}
      <Main>
        <LogoArea>
          <Logo width={64} height={64} />
          <LogoText className="logo-text">METAPHYSIO</LogoText>
          <LogoSubtitle className="logo-subtitle">Healthcare Solutions</LogoSubtitle>
        </LogoArea>

        <WelcomeBox>
          <FormTitle>{labels[language].loginTitle || 'Bienvenido'}</FormTitle>
          <FormSubtitle>Inicia sesión para acceder a la plataforma</FormSubtitle>

          <InputGroup>
            <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
            </svg>
            <Input
              placeholder={labels[language].email}
              required
              fullWidth
              id="email"
              name="email"
              autoComplete="email"
              autoFocus
              onChange={(e) => handleChange(e)}
            />
          </InputGroup>

          <InputGroup>
            <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
            </svg>
            <Input
              placeholder={labels[language].password}
              disabled={['obramat.es', 'obramat.pt', 'ext.obramat.pt', 'ext.obramat.es'].includes(values.email.split('@')[1])}
              required
              fullWidth
              name="password"
              type={showPassword ? 'text' : 'password'}
              id="password"
              autoComplete="current-password"
              endAdornment={<ShowPasswordButton onClick={() => setShowPassword(!showPassword)} />}
              onChange={(e) => handleChange(e)}
            />
          </InputGroup>

          {error && (
            <FormHelperText sx={{ mt: '4px', mb: '4px' }} error id="form-login">
              {error}
            </FormHelperText>
          )}

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1.5, mt: 0.25 }}>
            <Link sx={{ textDecoration: 'none', cursor: 'pointer', fontSize: '0.8rem', fontWeight: 500, color: '#1a96b8' }} onClick={() => setRecoverPasswordDialog(true)}>
              {labels[language].forgotPass}
            </Link>
          </Box>

          <LoadingButton
            disabled={!values.email || !values.password || ['obramat.es', 'obramat.pt', 'ext.obramat.pt', 'ext.obramat.es'].includes(values.email.split('@')[1])}
            type="button"
            onClick={handleSubmit}
            loading={loading}
            fullWidth
            variant="contained"
            sx={PrimaryButton}
          >
            {labels[language].login}
          </LoadingButton>

          <LoadingButton
            disabled={!['obramat.es', 'obramat.pt', 'ext.obramat.pt', 'ext.obramat.es'].includes(values.email.split('@')[1])}
            type="button"
            onClick={loginWithOIDC}
            loading={loading}
            fullWidth
            variant="outlined"
            sx={SecondaryButton}
          >
            <svg style={{ width: 18, height: 18, marginRight: 8 }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1121.75 8.25z" />
            </svg>
            Iniciar sesión con PingId
          </LoadingButton>

          <SimpleDialog
            open={openRecoverPass}
            handleClose={() => setOpenRecoverPass(false)}
            title={labels[language].weSendEmail}
            text={labels[language].recoverYourPassword}
          />
          <SimpleDialog
            category="error"
            open={openRecoverPassError}
            handleClose={() => setOpenRecoverPassError(false)}
            title={labels[language].errorWhenSendingEmail}
            text={labels[language].errorWhenSendingEmail2}
          />
          <RecoverPasswordDialog
            open={recoverPasswordDialog}
            handleClose={() => setRecoverPasswordDialog(false)}
            handleAction={recoverPassword}
            loading={loadingRecover}
          />
        </WelcomeBox>
      </Main>

      {/* RIGHT: Decorative Panel */}
      <DecorativePanel>
        {/* Particles */}
        {[0, 1, 2, 3].map((i) => <Particle key={`p${i}`} index={i} />)}

        {/* Hexagons */}
        {[0, 1, 2, 3, 4].map((i) => <Hexagon key={`h${i}`} index={i} />)}

        {/* Pulse line */}
        <PulseLine>
          <svg viewBox="0 0 1200 60" preserveAspectRatio="none">
            <path
              d="M0 30 L100 30 L120 30 L140 10 L160 50 L180 20 L200 40 L220 30 L400 30 L420 30 L440 8 L460 52 L480 18 L500 42 L520 30 L700 30 L720 30 L740 12 L760 48 L780 22 L800 38 L820 30 L1000 30 L1020 30 L1040 10 L1060 50 L1080 20 L1100 40 L1120 30 L1200 30"
              stroke="rgba(26, 150, 184, 0.8)" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"
            />
          </svg>
        </PulseLine>

        {/* Circuit lines & dots */}
        {[0, 1, 2].map((i) => <CircuitLine key={`cl${i}`} index={i} />)}
        {[0, 1, 2].map((i) => <CircuitDot key={`cd${i}`} index={i} />)}

        {/* DNA Helix */}
        <DnaContainer>
          {Array.from({ length: 20 }, (_, i) => <DnaDot key={`dna${i}`} index={i} />)}
        </DnaContainer>

        {/* Content */}
        <RightContent>
          <h3>{labels[language].welcomeTitle1}<br /><strong>{labels[language].welcomeTitle2}</strong></h3>
          <p>{labels[language].welcomeSubtitle}</p>
          <FeaturePills>
            <Pill>📅 {labels[language].welcomePill1}</Pill>
            <Pill>👥 {labels[language].welcomePill2}</Pill>
            <Pill>🛡️ {labels[language].welcomePill3}</Pill>
            <Pill>📈 {labels[language].welcomePill4}</Pill>
          </FeaturePills>
        </RightContent>
      </DecorativePanel>
    </LoginContainer>
  )
}
